const Semester = require('./Semester')
const html = require('nanohtml')
const _ = require('morphable')

const router = _({
  active: null,
  setActive (year = 0) {
    this.active = year
  }
})

const setActive = function (e, index) {
  router.setActive(index)
  e.preventDefault()
}

const newYear = function (state) {
  state.newYear()
  setTimeout(function () {
    router.setActive(state.years.length - 1)
  }, 1)
}

module.exports = _(function (state) {
  if (state.years.length > 0) {
    if (router.active == null) {
      router.setActive(0)
    } else {
      const len = state.years.length
      var current = state.years[router.active]
      for (var i = len - 1; i >= 0; i++) {
        if (current) {
          break
        } else {
          router.setActive(router.active - 1)
          current = state.years[router.active]
        }
      }
    }
  }

  if (current && current.semesters.length === 0) {
    current.newSemester()
  }

  return html`<div id="calc">
    <header>
      <table id="base-credits" class="${state.currentCredits == 0 ? `no-base-credits` : ``}">
        <tr>
          <td>Current Credits</td>
          <td><input onchange=${e => state.currentCredits = Number(e.target.value)}  type="text" value=${Number(state.currentCredits)}></td>
        </tr>
        <tr>
          <td style="font-size: 0.7em;">(Optional)</td>
          <td></td>
        </tr>
        <tr>
          <td>Current Weighted GPA</td>
          <td><input onchange=${e => state.currentGPA = Number(e.target.value)} type="text" value=${Number(state.currentGPA)}></td>
        </tr>
        <tr>
          <td style="font-size: 0.7em;">(Optional)</td>
          <td></td>
        </tr>
      </table>
      <h2 id="cumulative-gpa">Cumulative Weighted GPA: ${(state.gpa || 0).toFixed(2)}</h2>
      <h3 id="total-credits">Total Credits: ${state.credits}</h3>
    </header>
    <div id="years" class="pure-menu pure-menu-horizontal pure-menu-scrollable">
      <ul class="pure-menu-list">
        ${state.years.map((year, index) => html`
          <li class="pure-menu-item ${router.active == index ? `pure-menu-selected` : ``}"><button onclick=${e => setActive(e, index)} class="pure-menu-link pure-button">${year.name}</button></li>
        `)}
        <li class="pure-menu-item"><button onclick=${() => newYear(state)} class="pure-menu-link pure-button">+</button></li>
      </ul>
    </div>
    ${state.years.length > 0 ? state.years.map((year, index) => html`
      <div class="year ${index == router.active ? `year-active` : ``}">
        <header>
          <h2>${year.name} <button class="pure-button" onclick=${() => confirm('Are you sure you want to remove this year?') ? year.remove() : ``}>x</button></h2>
        </header>
        <div class="semesters">
          ${year.semesters.map(semester => Semester(semester))}
        </div>
        <footer>
          ${YearTools(year)}
        </footer>
      </div>
    `) : `Please add a year to continue`}
  </div>`
})

function YearTools (year) {
  return html`
    <div class="year-gpa">
      <h3>${year.name} GPA: ${(year.gpa || 0).toFixed(2)}</h3>
      <h4>Unweighted: ${(year.unweighted || 0).toFixed(2)}</h4>
      <h4>Credits: ${year.credits || 0}</h4>
    </div>
    <div class="year-tools">
      <button class="pure-button" onclick=${() => year.newSemester()}>Add a Semester</button>
    </div>
  `
}
